<div class="custom-background">
    <div class="row logo-margin">
        <div class="col-12 text-center">
            <img class="logo" src="./assets/images/logos/logo_bankei.png">
        </div>
    </div>

    <div class="row container-fluid m-0">
        <div class="col-lg-6 col-md-6 col-sm-12 login-container-padding-left my-4">
            <div class="title">Portal de Empresas</div>
            <div class="subtitle">Acesse para administrar benefícios e outros créditos.</div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 login-container-padding-right">
            <form [formGroup]="loginFormGroup" #loginForm="ngForm" autocomplete="new-password" (ngSubmit)="onSubmit(loginFormGroup.value)">
                <div class="my-3">
                    <div class="custom-input-container">
                        <input formControlName="documento" id="documento" class="custom-input" type="documento" [textMask]="{mask: MASKS.cpf.textMask}" autocomplete="new-password" />
                        <label class="custom-label" for="documento">Usuário</label>
                    </div>
                    <div *ngIf="form.documento.invalid && (form.documento.dirty || form.documento.touched)" class="custom-text-danger">
                        <div *ngIf="form.documento.errors.required">
                            O usuário é obrigatório!
                        </div>
                        <div *ngIf="form.documento.errors.cpf">
                            Este usuário é inválido!
                        </div>
                    </div>
                </div>

                <div class="my-4">
                    <div class="custom-input-container ">
                        <input onlyNumber formControlName="password" maxlength="10" id="password" type="password" class="custom-input" autocomplete="new-password" />
                        <label class="custom-label" for="password">Senha</label>
                    </div>
                    <div *ngIf="!error && form.password.invalid && (form.password.dirty || form.password.touched)" class="custom-text-danger">
                        <div *ngIf="form.password.errors.required">
                            A senha é obrigatória!
                        </div>
                    </div>
                </div>

                <div *ngIf="error && !blocked" class="text-center custom-text-danger">Tentativa de entrada inválida. Há {{tries}} tentativas restantes.</div>
                <div *ngIf="blocked" class="text-center custom-text-danger">Houve várias tentativas inválidas e seu acesso está bloqueado por 15 minutos. Tente mais tarde.</div>

                <div class="row my-2">
                    <div class="col-12 text-right pb-4 d-flex justify-content-end">
                        <button class="login-button-submit">
                            <span>Iniciar</span>
                            <img src="./assets/icons/arrow-right.svg">
                        </button>
                        <!-- <button [disabled]="!loginForm.valid || blocked" type="submit" class="login-button">Entrar</button> -->
                    </div>
                </div>
            </form>

            <div class="row text-center">
                <div class="col-6 login-option" (click)="password()">Recuperar senha</div>
                <div class="col-6 login-option" (click)="register()">Credenciar minha empresa</div>
            </div>
        </div>
    </div>
</div>
